import MobileCarousel from "./MobileCarousel";
import StaticGrid from "./ui/static-grid";

const ResponsiveGrid = () => {
    return (
      <>
        <div className="hidden lg:block">
          <StaticGrid />
        </div>
        <div className="block lg:hidden">
          <MobileCarousel />
        </div>
      </>
    );
  };

export default ResponsiveGrid;